"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("../button");
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _TableFilter = _interopRequireDefault(require("./TableFilter.style"));
var _index = _interopRequireDefault(require("../collapse/FilterCollapse/index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TableFilter = function TableFilter(_ref) {
  var title = _ref.title,
    filterButtonText = _ref.filterButtonText,
    onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    list = _ref.list,
    selected = _ref.selected,
    hasChanges = _ref.hasChanges,
    disabled = _ref.disabled,
    isExpanded = _ref.isExpanded,
    onExpandToggle = _ref.onExpandToggle,
    virtualized = _ref.virtualized;
  var expandTriggerProps = {};
  if (!disabled) {
    expandTriggerProps = {
      onClick: function onClick() {
        return onExpandToggle(!isExpanded);
      },
      onKeyDown: function onKeyDown() {
        return onExpandToggle(!isExpanded);
      },
      role: 'button',
      tabIndex: '0'
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_TableFilter["default"], {
    className: "filter-wrapper",
    isExpanded: isExpanded && !disabled,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-header"
  }, isExpanded && !disabled && /*#__PURE__*/_react["default"].createElement("span", {
    className: "filter-title"
  }, title), /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    className: "filter-icon",
    icon: "ion-android-funnel"
  }, expandTriggerProps, {
    "aria-label": "Toggle filters"
  }))), isExpanded && !disabled && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-content"
  }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
    items: list,
    selectedItems: selected,
    onChange: onChange,
    virtualized: virtualized
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-footer"
  }, /*#__PURE__*/_react["default"].createElement(_button.Button, {
    medium: true,
    fullWidth: true,
    action: function action() {
      onSubmit();
    },
    id: "applyFilters",
    disabled: !hasChanges
  }, filterButtonText))));
};
TableFilter.defaultProps = {
  disabled: false,
  hasChanges: true,
  selected: {},
  virtualized: false
};
TableFilter.propTypes = {
  /** The title of the filter */
  title: _propTypes["default"].string.isRequired,
  /** The title of the filter */
  disabled: _propTypes["default"].bool,
  /** Callback for when clicking a new filter */
  onChange: _propTypes["default"].func.isRequired,
  /** Callback for when applying the filters */
  onSubmit: _propTypes["default"].func.isRequired,
  /** Flag to indicate when the filter should be exanded */
  isExpanded: _propTypes["default"].bool.isRequired,
  /** Callback for when clicking on the expand button */
  onExpandToggle: _propTypes["default"].func.isRequired,
  /** Filter options */
  list: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      count: _propTypes["default"].number,
      value: _propTypes["default"].string
    }))
  })).isRequired,
  /** Selected filter options */
  selected: _propTypes["default"].shape({}),
  /** Flag to indicate if there are changes in the filters */
  hasChanges: _propTypes["default"].bool,
  /** Filter button string */
  filterButtonText: _propTypes["default"].string.isRequired,
  /** Flag to indicate if list should be virtualized */
  virtualized: _propTypes["default"].bool
};
var _default = exports["default"] = TableFilter;